import * as toolbox from 'components/common/toolbox';
import AttachmentsTab from 'components/attachments/attachments-tab';
import Authorize from 'components/common/authorize';
import Badge from 'components/common/Badge';
import CatchErrors from 'components/common/catch-errors';
import InvoicesTab from 'components/invoices/invoices-tab';
import PaymentsTab from 'components/payments/payments-tab';
import QuotesTab from 'components/quotes/quotes-tab';
import React, { useEffect } from 'react';
import WorkOrdersTab from 'components/work-orders/work-orders-tab';
import _ from 'lodash';
import firebase from 'firebase/compat/app';
import { APPS, LOG, PERMISSIONS, ROLES, SERVICE_REQUEST_TERMS, QUOTES } from 'components/constants';
import { Route, useHistory, useLocation, useParams, useRouteMatch } from 'react-router-dom';
import { Spinner } from 'enspire-manager-framework';
import { numPanels } from 'components/common/toolbox';
import { useSelector } from 'react-redux';

const firestore = firebase.firestore();

export default function ServiceRequestTabs(props) {
	
	/* Handlers --------------------------*/
	
	const seg = 9;
	const match = useRouteMatch();
    const params = useParams();
	const history = useHistory();
	const routeLocation = useLocation();

	const assets = useSelector((store) => store.assets.assets);
	const serviceRequests = useSelector((store) => store.serviceRequests);
	const service_request = useSelector((store) => store.serviceRequests.service_request);
	const settings = useSelector((store) => store.settings);
	const user = useSelector(store => store.users?.user);
	const user_permissions = useSelector(store => store.users?.user_permissions);

	const asset = assets.find((asset) => asset.id == service_request?.assetId);

	const segments = routeLocation.pathname.split('/').length;
	const isRecord = (service_request?.type == 'asset_record');

	// Permissions ----------------------------------------

	const isAsset = (params.appId == APPS.ASSETS.id);
	const isCustomerAssigned = (isAsset) ? (asset?.customerId === user?.profileId) : false;
	
	const isTeamWO = (service_request?.techIds?.includes(user?.profileId) || service_request?.techIds?.includes(user?.email));
	const canView = (
		(isTeamWO && user_permissions[PERMISSIONS.SERVICE_REQUESTS_ASSIGNED_VIEW.key]) ||
		(user_permissions[PERMISSIONS.SERVICE_REQUESTS_VIEW.key])
	);
	const canEdit = (
		(isTeamWO && user_permissions[PERMISSIONS.SERVICE_REQUESTS_ASSIGNED_EDIT.key]) ||
		user_permissions[PERMISSIONS.SERVICE_REQUESTS_EDIT.key]
	);

	/* Effects ---------------------------------------------------------------------------------------------------------------------------*/

	const tab_active = (value) => {
		return (params.tab === value) ? ' active' : ''; // returns 'active' if value tab is active
	}
	const link_tab = (value, event) => {
		event.preventDefault();
		let num = (segments >= 12) ? -1 : 0;
		if (num) history.go(num);

		setTimeout(() => {
			history.replace(toolbox.modifyPath(props.location.pathname, seg, value, seg+1));
		}, 50);
	}

	return (
		<>
			{ !isRecord && 
				<Authorize perm={ PERMISSIONS.SERVICE_REQUESTS_VIEW } or={ canView }>
					<div className="tabs-container mt-1 mb-4 position-relative">
						<ul className={ `nav nav-tabs underline ${(numPanels(1))?'scroll-tabs':''}` } role="tablist">
							<Authorize permKeys={ [PERMISSIONS.WORK_ORDERS_VIEW.key, PERMISSIONS.WORK_ORDERS_ASSIGNED_VIEW.key] }>
								<li className="position-relative">
									<Badge type={'info'} number={service_request?.workOrderIds?.length} />
									<a className={'nav-link' + tab_active('work_orders')} onClick={link_tab.bind(this, 'work_orders')}>
										<i title="Work Orders" className="fa-duotone fa-solid fa-file-circle-check fa-2x m-0"></i>
										<br />WO
									</a>
								</li>
							</Authorize>
							<Authorize feature={'generate_quotes'} perm={ PERMISSIONS.QUOTES_VIEW }>
								<li className="position-relative">
									<Badge type={'info'} number={service_request?.quoteCount ?? 0} />
									<a className={'nav-link' + tab_active('quotes')} onClick={link_tab.bind(this, 'quotes')}>
										<i title="Quotes" className="fa-duotone fa-solid fa-message-quote fa-2x m-0"></i>
										<br />QT
									</a>
								</li>
							</Authorize>
							<Authorize feature={'generate_invoices'} perm={ PERMISSIONS.INVOICES_VIEW }>
								<li className="position-relative">
									<Badge type={'info'} number={service_request?.invoiceCount ?? 0} />
									<a className={'nav-link' + tab_active('invoices')} onClick={link_tab.bind(this, 'invoices')}>
										<i title="Invoices" className="fa-duotone fa-solid fa-file-lines fa-2x m-0"></i>
										<br />INV
									</a>
								</li>
							</Authorize>
							<Authorize feature={'manage_payments'} perm={ PERMISSIONS.PAYMENTS_VIEW }>
								<li className="position-relative">
									<Badge type={'info'} number={service_request?.paymentCount ?? 0} />
									<a className={'nav-link' + tab_active('payments')} onClick={link_tab.bind(this, 'payments')}>
										<i title="Payments" className="fa-duotone fa-solid fa-file-invoice-dollar fa-2x m-0"></i>
										<br />PMT
									</a>
								</li>
							</Authorize>
							<Authorize permKeys={ [PERMISSIONS.WORK_ORDERS_VIEW.key, PERMISSIONS.WORK_ORDERS_ASSIGNED_VIEW.key] }>
								<li className="position-relative">
									<Badge type={'info'} number={serviceRequests?.service_request_attachments?.length || 0} />
									<a className={'nav-link' + tab_active('attachments')} onClick={link_tab.bind(this, 'attachments')}>
										<i title="Attachments" className="fa-duotone fa-solid fa-paperclip fa-2x mr-0"></i>
										<br />ATT
									</a>
								</li>
							</Authorize>
						</ul>

						<div className="tab-content">

							<Authorize permKeys={ [PERMISSIONS.WORK_ORDERS_VIEW.key, PERMISSIONS.WORK_ORDERS_ASSIGNED_VIEW.key] }>
								<div role="tabpanel" className={'tab-pane' + tab_active('work_orders')}>
									<div className="panel-body">
										<Route path={match.path} render={(route_props) =>
											<CatchErrors>
												<WorkOrdersTab {...route_props} source={ props.source} />
											</CatchErrors>
										} />
									</div>
								</div>
							</Authorize>
							<Authorize feature={'generate_quotes'} perm={ PERMISSIONS.QUOTES_VIEW }>
								<div role="tabpanel" className={'tab-pane' + tab_active('quotes')}>
									<div className="panel-body">
										<Route path={match.path} render={(route_props) =>
											<CatchErrors>
												<QuotesTab {...route_props} source="service-requests" />
											</CatchErrors>
										} />
									</div>
								</div>
							</Authorize>
							<Authorize feature={'generate_invoices'} perm={ PERMISSIONS.INVOICES_VIEW }>
								<div role="tabpanel" className={'tab-pane' + tab_active('invoices')}>
									<div className="panel-body">
										<Route path={match.path + '/:invoice_id?'} render={(route_props) =>
											<CatchErrors>
												<InvoicesTab {...route_props}
													prefix="SERVICE_REQUEST" 
													singular='service_request' 
													source='service-requests' 
													store="serviceRequests" 
												/>
											</CatchErrors>
										} />
									</div>
								</div>
							</Authorize>
							<Authorize feature={'manage_payments'} perm={ PERMISSIONS.PAYMENTS_VIEW }>
								<div role="tabpanel" className={'tab-pane' + tab_active('payments')}>
									<div className="panel-body">
										<Route path={match.path + '/:payment_id?'} render={(route_props) =>
											<CatchErrors>
												<PaymentsTab {...route_props} source='service-requests' />
											</CatchErrors>
										} />
									</div>
								</div>
							</Authorize>
							<Authorize permKeys={ [PERMISSIONS.WORK_ORDERS_VIEW.key, PERMISSIONS.WORK_ORDERS_ASSIGNED_VIEW.key] }>
								<div role="tabpanel" className={'tab-pane' + tab_active('attachments')}>
									<div className="panel-body">
										<Route path={match.path} render={(route_props) =>
											<CatchErrors>
												<AttachmentsTab {...route_props} 
													id={ params.request_id } 
													columnId={ (props.source == 'service')? "column2" : "column3"}
													name="Service Request" 
													permissions={{ canView, canEdit }}
													prefix="SERVICE_REQUEST"
													singular="service_request" 
													source='service-requests' 
													store="serviceRequests" 
													setFocused={ props.setFocused }
												/>
											</CatchErrors>
										} />
									</div>
								</div>
							</Authorize>
						</div>
					</div>
				</Authorize>
			}
		</>
	);
};